import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-desing-test',
  templateUrl: './desing-test.component.html',
  styleUrls: ['./desing-test.component.css']
})
export class DesingTestComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
